export default __webpack_public_path__ + "static/client-intelligence-v2-d8a105d47a0ac4047544348082524664.svg";